function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtrInc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.663057mm",
    height: "24.827337mm",
    viewBox: "0 0 17.663057 24.827337",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-138.81462,-180.76898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 147.58054,181.26196 v 23.84138 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 154.94299,181.31638 -7.3358,23.7375 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 140.21701,181.31638 7.3358,23.7375 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 139.3076,184.75786 h 16.6771 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 139.3076,187.05643 h 16.6771 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 139.3076,189.355 h 16.6771 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtrInc3);
export default __webpack_public_path__ + "static/media/dtr-inc-3.f0c8096ed6542806987913bc57e24979.svg";
export { ForwardRef as ReactComponent };